var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../../../../defaultTheme';
const dotflashing = () => keyframes `
  50%,100% { background-color: transparent }
`;
const DotLoaderContainer = styled.div `
  display: inline-block;
`;
const Dot = styled.div `
  &:not(:last-child) {
    margin-right: ${({ dotSize }) => dotSize / 2}px;
  }
  display: inline-block;
  width: ${({ dotSize }) => dotSize}px;
  height: ${({ dotSize }) => dotSize}px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  color: ${({ color }) => color};
  animation: ${dotflashing} 1s infinite alternate;
  animation-delay: ${({ delay }) => delay}s;
`;
const DotLoader = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const dotProps = Object.assign(Object.assign({}, props), { dotSize: props.dotSize || 10, color: props.color || colors.cyanBlue });
    return (React.createElement(DotLoaderContainer, { className: className },
        React.createElement(Dot, Object.assign({ delay: 0 }, dotProps)),
        React.createElement(Dot, Object.assign({ delay: 0.5 }, dotProps)),
        React.createElement(Dot, Object.assign({ delay: 1 }, dotProps))));
};
export default DotLoader;
